exports.onRouteUpdate = () => {
  window.dataLayer.push({ event: "gatsby-route-change" });
};
